export const openRelatedRecordingForScreenshot = ({
  recordingId,
  startTime,
  siteId,
}: {
  recordingId: number;
  startTime: number;
  siteId: number;
}): void => {
  const searchParams = new URLSearchParams();
  searchParams.append('site', String(siteId));
  searchParams.append('recording', String(recordingId));
  searchParams.append('startTime', String(startTime));
  searchParams.append('forScreenshot', '1');
  window.open(`${document.location.origin}/r?${searchParams}`, '_blank');
};
